// src/mocks/handlers/analytics.handlers.js
import * as data from '../data/analytics.demo';

export const getDashboard = async () => data.dashboard;
export const getDailyInvoiceStats = async () => data.dailyInvoiceStats;
export const getDailySalesStats = async () => data.dailySalesStats;
export const getAverageInvoiceValue = async () => data.averageInvoiceValue;
export const getBestSellers = async (config) => {
    const period = config?.params?.period || 'week';
    if (period === 'month') return data.bestSellersMonth;
    if (period === 'day')   return data.bestSellersDay;
    return data.bestSellersWeek;
};
export const getTopProducts = async (config) => {
    const period = config?.params?.period || 'day';
    if (period === 'month') return data.topProductsMonth;
    if (period === 'week')  return data.topProductsWeek;
    return data.topProductsDay;
};
export const getSalesByCategory = async () => data.salesByCategory;
export const getInvoiceDates = async () => data.invoiceDates;
export const getSalesTrend = async (config) => {
    const days = config?.params?.days || 7;
    // 7  → last 7  entries (Jan 7–13)
    // 30 → last 28 entries (Dec 15 – Jan 13 — 28 trading days)
    // 90 → all 89 entries (Oct 15 – Jan 13)
    const all   = data.TREND_DATA;
    const slice = days >= 90 ? all : days >= 30 ? all.slice(-28) : all.slice(-7);
    const total = slice.reduce((s, d) => s + d.TotalSales, 0);
    const peak  = slice.reduce((m, d) => d.TotalSales > m.TotalSales ? d : m, slice[0]);
    return {
        success: true,
        data: slice,
        summary: {
            TotalSales:    Math.round(total),
            AvgDailySales: Math.round(total / slice.length),
            PeakSales:     peak.TotalSales,
            PeakDay:       peak.Date,
        },
    };
};
export const getCategoryTrend = async () => data.categoryTrend;
export const getPaymentMethods = async () => data.paymentMethods;
